import { render, staticRenderFns } from "./ModalSupportText.vue?vue&type=template&id=44e09e08&scoped=true&"
import script from "./ModalSupportText.vue?vue&type=script&lang=ts&"
export * from "./ModalSupportText.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSupportText.vue?vue&type=style&index=0&id=44e09e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e09e08",
  null
  
)

export default component.exports